// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__22gH3","header":"PatientBlock_header__mdtCl","label":"PatientBlock_label__2185R","option":"PatientBlock_option__5Ahi3"};